<elcia-dropdown
  [control]="control()"
  [items]="licencePlans()"
  [label]="'product.licence-plan' | translate"
  [textField]="'name'"
  [valueField]="'id'"
/>
